import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, DataTable, LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const SettingsNotificationFormSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="m">
			<ContentLayout>
				<GovSkeleton
					height="28px"
					width="270px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<GovSkeleton
					height="22px"
					width="90%"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<DataTable customClasses="gov-skeleton-no-mb mt-4">
					<thead>
						<tr>
							<th className="w-4/6 [ md:w-3/6 ]">&nbsp;</th>
							<th className="md:w-1/6">
								<GovSkeleton
									height="19px"
									width="60px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</th>
							<th className="md:w-1/6">
								<GovSkeleton
									height="19px"
									width="60px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{Array.from({ length: 4 }).map(() => (
							<tr>
								<td className="pb-0!">
									<GovSkeleton
										height="19px"
										width={generateRandomNumber(28, 50) + '%'}
										aria-label={t('loading.wcag.processing', {
											namespace: LocalizeNameSpaceTypes.Global,
										})}
									/>
								</td>
								<td className="text-center">
									<GovSkeleton
										height="24px"
										width="24px"
										aria-label={t('loading.wcag.processing', {
											namespace: LocalizeNameSpaceTypes.Global,
										})}
									/>
								</td>
								<td className="text-center">
									<GovSkeleton
										height="24px"
										width="24px"
										aria-label={t('loading.wcag.processing', {
											namespace: LocalizeNameSpaceTypes.Global,
										})}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</DataTable>
			</ContentLayout>
		</LayoutGap>
	);
};
